module.exports = __webpack_public_path__ + "static/img/2.3.86bb13e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/picture/2.3.jpg
// module id = d5/4
// module chunks = 7